import React from 'react';
import { useSmartNav } from '../../hooks/useSmartNav';

const Footer = () => {
  const goTo = useSmartNav();
  const links = [
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Product', href: '/product' },
    { label: 'Pricing', href: '/pricing' },
    // { label: 'For Your Firm', href: '/mockup/lp-002' }, // Hidden until launch (user will reintroduce later)
    { label: 'Insights', href: '/insights' },
    { label: 'Subscribe to Paper Trail', href: 'https://archen.beehiiv.com/subscribe', external: true },
    { label: 'Talk to the founders', href: 'https://calendly.com/hello-archen', external: true },
  ];
  return (
    <footer className="bg-[#FDF8F3] border-t border-[#E5DDD0] py-14">
      <div className="content-container">
        <p
          className="text-center text-[#7A5A2E] text-[13px] italic mb-10"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Built for interior design studios. Expanding to the entire built world.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <img
              src="https://customer-assets.emergentagent.com/job_archen-studio/artifacts/kz0rmfk8_logo.svg"
              alt="Archen™"
              className="h-6 w-auto"
            />
            <span
              className="text-[#2D2520] text-lg tracking-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
            >
              Archen™
            </span>
          </div>

          <nav className="flex flex-wrap items-center gap-x-7 gap-y-3 text-[#5C4F42] text-[13.5px]">
            {links.map((link) =>
              link.external ? (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#2D2520] transition-colors"
                >
                  {link.label}
                </a>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); goTo(link.href); }}
                  className="hover:text-[#2D2520] transition-colors"
                >
                  {link.label}
                </a>
              )
            )}
          </nav>

          <p className="text-[#6B655C] text-[12px]">© 2026 Archen™</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
